import { render } from "./materialCDRView.vue?vue&type=template&id=32fc1da7"
import script from "./materialCDRView.vue?vue&type=script&lang=js"
export * from "./materialCDRView.vue?vue&type=script&lang=js"

import "./materialCDRView.vue?vue&type=style&index=0&id=32fc1da7&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__